import React, {MouseEvent} from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import navigateToURL from 'lib/navigateToURL';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import {getTestDefinitionURL} from 'sample-tests/network/TestDefinitionDAO';
import * as TestDefinitionContextMenu from 'sample-tests/search/TestDefinitionContextMenu';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {TestDefinitionListingGraphQL} from '../../../graphql-fragments/sample_tests/__generated/TestDefinitionListingGraphQL';

interface TestDefinitionSidepanelItemProps {
  isActive: boolean;
  isCompact: boolean;
  isChild: boolean;
  testDefinition: TestDefinitionListingGraphQL;
  openResult: (item: TestDefinitionListingGraphQL) => void;
}

export default function TestDefinitionSidepanelItem(props: TestDefinitionSidepanelItemProps): JSX.Element {
  const {isActive, isCompact, isChild, testDefinition} = props;
  const icon = <BenchlingIcon icon={ModelTypeConstants.TEST_DEFINITION} />;

  const handleOpenContextMenu = (e: MouseEvent): void => {
    TestDefinitionContextMenu.open(e.nativeEvent, props.testDefinition);
  };

  return (
    <SidepanelItem
      active={isActive}
      className="sidepanelItem--noIcon"
      faded={testDefinition.archiveData?.archived}
      icon={icon}
      isCompact={isCompact}
      onClick={() => {
        navigateToURL(getTestDefinitionURL(testDefinition.id));
      }}
      onContextMenu={handleOpenContextMenu}
      title={{text: testDefinition.name}}
      tooltipText=""
      isExpandable={false}
      isChild={isChild}
    />
  );
}
